export default "/fonts/vendor/@coreui/icons/CoreUI-Icons-Free.eot?246845e88bc1880edca64e16367b2bd9";